// @ts-nocheck
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductVisualizerButton, {
    ProductVisualizerButtonPresentationProps,
} from "@store/Library/Components/ProductVisualizerButton";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface ProductDetailsVisualizerButtonProps extends WidgetProps {}

export interface ProductDetailsVisualizerButtonStyles extends ProductVisualizerButtonPresentationProps {}

export const productDetailsVisualizerButtonStyles: ProductDetailsVisualizerButtonStyles = {
    extendedStyles: {
        button: {
            mergeCss: true,
            css: css`
                margin: ${pxToRem(24, 0, 0)} auto;
            `,
        },
    },
};

const styles = productDetailsVisualizerButtonStyles;

const ProductDetailsVisualizerButton: FC<ProductDetailsVisualizerButtonProps> = () => {
    const { product } = useContext(ProductContext);

    return <ProductVisualizerButton {...styles} productNumber={product.productNumber} />;
};

const widgetModule: WidgetModule = {
    component: ProductDetailsVisualizerButton,
    definition: {
        displayName: "Visualizer Button",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [],
    },
};

export default widgetModule;
